// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MilestonesEvolution_sectionTitle__2W3mI","fadeIn":"MilestonesEvolution_fadeIn__Na0Ki","fadeOut":"MilestonesEvolution_fadeOut__2zvkq"};